module.exports = __webpack_public_path__ + "static/media/gallery-19.c4cb458e.jpg";